import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { PageHeader } from '@carrent/ui'
import { ticketsApi } from '@carrent/api'

const STATUS_STYLE = {
  open:        { color: 'var(--accent)',  bg: 'rgba(59,130,246,0.1)', icon: '📭', label: 'Открыто' },
  in_progress: { color: 'var(--accent)',  bg: 'rgba(59,130,246,0.1)', icon: '🔄', label: 'В работе' },
  waiting:     { color: 'var(--warning)', bg: 'rgba(245,158,11,0.1)', icon: '💬', label: 'Ответ от менеджера' },
  resolved:    { color: 'var(--success)', bg: 'rgba(34,197,94,0.1)',  icon: '✅', label: 'Решено' },
  closed:      { color: 'var(--text-muted)', bg: 'var(--bg-card)',     icon: '🔒', label: 'Закрыто' },
}

const TABS = [
  { value: 'active', label: 'Активные', icon: '💬' },
  { value: 'closed', label: 'Закрытые', icon: '✅' },
]

function TicketCard({ ticket, onClick }) {
  const s = STATUS_STYLE[ticket.status] || STATUS_STYLE.open
  const unread = ticket.unread_count || 0

  return (
    <div className="card" style={{ cursor: 'pointer', padding: 0, overflow: 'hidden' }}
      onClick={onClick}>
      <div style={{ height: 3, background: s.color }} />

      <div style={{ padding: 'var(--gap-sm) var(--gap)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <p style={{ fontWeight: 700, fontSize: '0.95rem',
              whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {ticket.subject}
            </p>
            <p className="text-muted" style={{ fontSize: '0.78rem', marginTop: 2 }}>
              {ticket.category_label} · #{ticket.id}
            </p>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4, flexShrink: 0 }}>
            <span style={{
              padding: '2px 8px', borderRadius: 99,
              background: s.bg, color: s.color,
              fontSize: '0.72rem', fontWeight: 700,
            }}>
              {s.icon} {s.label}
            </span>
            {unread > 0 && (
              <span style={{
                background: 'var(--danger)', color: '#fff',
                padding: '2px 8px', borderRadius: 99,
                fontSize: '0.7rem', fontWeight: 700,
              }}>
                {unread} новых
              </span>
            )}
          </div>
        </div>

        {ticket.car && (
          <p className="text-muted" style={{ fontSize: '0.78rem', marginTop: 4 }}>
            🚗 {ticket.car.brand} {ticket.car.model} · {ticket.car.plate}
          </p>
        )}

        {ticket.last_message && (
          <p style={{
            fontSize: '0.82rem', marginTop: 6, padding: '6px 8px',
            background: 'var(--bg)', borderRadius: 'var(--r-sm)',
            color: 'var(--text-muted)',
            whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
          }}>
            <span style={{ color: ticket.last_message.is_admin ? 'var(--accent)' : 'var(--text)' }}>
              {ticket.last_message.is_admin ? '🔧 Менеджер: ' : 'Вы: '}
            </span>
            {ticket.last_message.preview}
          </p>
        )}

        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 6,
          fontSize: '0.72rem', color: 'var(--text-muted)' }}>
          <span>{new Date(ticket.created_at).toLocaleDateString('ru')}</span>
          <span>{ticket.messages_count} сообщ.</span>
        </div>
      </div>
    </div>
  )
}

export default function SupportPage() {
  const navigate = useNavigate()
  const [tickets, setTickets]   = useState([])
  const [loading, setLoading]   = useState(true)
  const [filter, setFilter]     = useState('active')

  const load = () => {
    setLoading(true)
    ticketsApi.list({ status: filter, per_page: 50 })
      .then(r => setTickets(r.data?.data?.items || []))
      .catch(() => {})
      .finally(() => setLoading(false))
  }

  useEffect(() => { load() }, [filter])

  return (
    <div>
      <PageHeader
        title="Поддержка"
        right={
          <button className="btn btn--primary"
            style={{ padding: '6px 14px', fontSize: '0.85rem' }}
            onClick={() => navigate('/support/new')}>
            + Создать
          </button>
        }
      />

      <div style={{ padding: '0 var(--gap) var(--gap-sm)' }}>
        <div style={{ display: 'flex', gap: 6 }}>
          {TABS.map(t => (
            <button key={t.value}
              className={`btn ${filter === t.value ? 'btn--primary' : 'btn--outline'}`}
              style={{ flex: 1, padding: '6px 12px', fontSize: '0.82rem' }}
              onClick={() => setFilter(t.value)}>
              {t.icon} {t.label}
            </button>
          ))}
        </div>
      </div>

      <div className="p-page flex-col" style={{ gap: 'var(--gap-sm)', paddingTop: 0 }}>
        {loading && (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}>
            <div className="spinner" />
          </div>
        )}

        {!loading && tickets.length === 0 && (
          <div style={{ textAlign: 'center', padding: '3rem 0' }}>
            <div style={{ fontSize: '3rem', marginBottom: 12 }}>💬</div>
            <p style={{ fontWeight: 600 }}>
              {filter === 'active' ? 'Нет активных обращений' : 'Нет закрытых обращений'}
            </p>
            {filter === 'active' && (
              <>
                <p className="text-muted" style={{ fontSize: '0.88rem', marginTop: 6 }}>
                  Создайте обращение если возникла проблема
                </p>
                <button className="btn btn--primary" style={{ marginTop: 'var(--gap)' }}
                  onClick={() => navigate('/support/new')}>
                  + Новое обращение
                </button>
              </>
            )}
          </div>
        )}

        {tickets.map(t => (
          <TicketCard key={t.id} ticket={t}
            onClick={() => navigate(`/support/${t.id}`)} />
        ))}
      </div>
    </div>
  )
}
